import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { SheduleService } from '../../../../services/shedule.service';
import { SubscriptionService } from '../../../../shared/services/subscription.service';
import { SheduleModel } from '../../../../models/SheduleModel';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Utilities } from '../../../../Utilities';
import { Subscription } from 'rxjs/Subscription';
import { DashboardService } from '../../../../services/dashboard.service';
import { BuyerUploadService } from '../../buyer-upload-section/services/buyer-upload.service';
import { LightboxConfig, Lightbox, IAlbum } from 'angular2-lightbox';
import { FileUploadModel } from '../../buyer-upload-section/Models/BuyerUploadModel';
import { DxDataGridComponent } from 'devextreme-angular';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-milestone',
  templateUrl: './milestone.component.html',
  styleUrls: ['./milestone.component.css']
})
export class MilestoneComponent implements OnInit, OnDestroy {
  SheduleModelList: SheduleModel[] = [];
  @ViewChild("milestoneGrid") milestoneGrid: DxDataGridComponent;
  public apiUrl: string = Utilities.getSecureFileUrl;
  private firstRefresh: boolean = true;
  private subscriptions: Subscription[] = [];
  public dateFormat: string = environment.serviceRequestDisplayDateFormat;

  constructor(
    public subscriptionService: SubscriptionService,
    public _lightbox: Lightbox,
    public _lighboxConfig: LightboxConfig,
    private buyerUploadService: BuyerUploadService,
    public sheduleService: SheduleService,
    public router: Router) { }

  ngOnInit() {
    this.subscriptions.push(this.subscriptionService.CommunityLotId$.subscribe(lotId => {
      if (lotId) {
        this.firstRefresh = true;
        this.subscriptions.push(this.sheduleService.GetMilestoneForBuyerByCommunityLotId(lotId, this.getContractId()).subscribe(x => {
          this.SheduleModelList = [];
          if (x && x.schedule) {
            this.SheduleModelList = x.schedule;
            this.SheduleModelList.forEach(element => {
               element.DueDate = Utilities.convertToStandardDateFormat(element.DueDate);
              // element.CompleteDate = Utilities.convertToStandardDateFormat(element.CompleteDate);
            });
          }
        }));
      }
    }));
  }

  private getContractId() {
    return this.subscriptionService.communityLots.some(x => x.CommunityLotId === this.subscriptionService.CommunityLotId$.getValue()) ?
      this.subscriptionService.communityLots.find(x => x.CommunityLotId === this.subscriptionService.CommunityLotId$.getValue()).ContractId : 0
  }

  public onImageClick(event: any, index: number, uploadFiles: FileUploadModel[]) {
    this._lighboxConfig.centerVertically = true;
    let album: Array<IAlbum> = uploadFiles.map(x => {
      return {
        src: this.apiUrl + x.FileAccessUrl,
        caption: x.ImageDisplayName,
        thumb: this.apiUrl + x.FileAccessUrl
      }
    });
    this._lightbox.open(album, index, { wrapAround: true, showImageNumberLabel: true });
  }

  // public onCellPrepared(event: any) {
  //   if (event.rowType === "data" && event.column.command === "expand") {
  //     if (event.data) {
  //       if (event.data.CountLotPicture === 0) {
  //         event.cellElement.classList.remove('dx-datagrid-expand');
  //         while (event.cellElement.firstChild) event.cellElement.removeChild(event.cellElement.firstChild);
  //       } else {
  //         debugger;
  //         this.milestoneGrid.instance.expandRow(event.rowIndex);
  //         //  .add("dx-datagrid-group-opened");
  //         // event.cellElement.children[0].classList.remove("dx-datagrid-group-closed");
  //       }
  //       if (this.firstRefresh) {
  //         this.firstRefresh = false;
  //         this.milestoneGrid.instance.refresh();
  //       }
  //     }
  //   }
  // }

  public onRowPrepared(event: any) {
    if (event.rowType === "data") {
      if (event.data) {
        if (event.data.CountLotPicture > 0) {
          this.milestoneGrid.instance.expandRow(event.key);
          if (this.firstRefresh) {
            this.firstRefresh = false;
            this.milestoneGrid.instance.refresh();
          }
        }
        event.cells[0].cellElement.classList.remove('dx-datagrid-expand');
        while (event.cells[0].cellElement.firstChild) event.cells[0].cellElement.removeChild(event.cells[0].cellElement.firstChild);
      }
    }
  }

  // public onContentReady(event: any) {
  //   // if (this.firstLoad == true) {
  //   //   this.firstLoad = false;
  //   let grid = event.component;
  //   grid.beginUpdate();
  //   debugger;
  //   let rows = grid.getDataSource().items();
  //   if (rows.length > 0) {
  //     for (let i = 0; i < rows.length; i++) {
  //       let row = rows[i];
  //       if (row.data) {
  //         if (row.data.CountLotPicture > 0) {
  //           grid.expandRow(row.data) // if the key option is specified at thee dataSource level, pass a key value
  //         }
  //       }
  //     }
  //   }
  //   grid.endUpdate();
  //   // }
  // }

  ngOnDestroy() {
    this.firstRefresh = true;
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  ViewImage(id: number) {
    this.router.navigate(['/homepictures', id]);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/schedule/milestone/milestone.component.ts